import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useEffect, useState } from "react"
import "./css/CreateExpense.css"
import { IoAddCircleSharp } from "react-icons/io5"
import { AiOutlineSearch } from "react-icons/ai"
import { Container, TextField } from "@mui/material"
import axios from "axios"
import api from "../config/backend"
import AddNewVendor from "../components/AddNewVendor"
import AddNewCustomer from "../components/AddNewCustomer"
import AddNewExpense from "../components/AddNewExpense"
import { toast } from "react-toastify"
import GalleryIcon from "../assets/icons/GalleryIcon.png"
import Compress from "compress.js"
import { Document, Page, pdfjs } from 'react-pdf'

const CreateExpense = ({ setCreateExpense }) => {
    const [expenseDate, setExpenseDate] = useState(undefined)
    const [selectedExpenseAccount, setSelectedExpenseAccount] = useState(false)
    const [expenseAccountInputOpen, setExpenseAccountInputOpen] = useState(false)
    const [addNewExpensePopup, setAddNewExpensePopup] = useState(false)
    const [addNewVendorPopup, setAddNewVendorPopup] = useState(false)
    const [addNewCustomerPopup, setAddNewCustomerPopup] = useState(false)
    const [expenseAccountInput, setExpenseAccountInput] = useState("")
    const [expensesUpdatedRefresh, setExpensesUpdatedRefresh] = useState(0)
    const [expenseAmount, setExpenseAmount] = useState("")
    const [selectedPaidThrough, setSelectedPaidThrough] = useState(undefined)
    const [paidThroughInputOpen, setPaidThroughInputOpen] = useState(false)
    const [paidThroughInput, setPaidThroughInput] = useState("")
    const [vendors, setVendors] = useState([])
    const [selectedVendor, setSelectedVendor] = useState(false)
    const [vendorInputOpen, setVendorInputOpen] = useState(false)
    const [vendorInput, setVendorInput] = useState("")
    const [vendorsUpdatedRefresh, setVendorsUpdatedRefresh] = useState(0)
    const [invoice, setInvoice] = useState("")
    const [notes, setNotes] = useState("")
    const [customers, setCustomers] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState(false)
    const [customerInputOpen, setCustomerInputOpen] = useState(false)
    const [customerInput, setCustomerInput] = useState("")
    const [customersUpdatedRefresh, setCustomersUpdatedRefresh] = useState(0)
    const [expenseAccountsList, setExpenseAccountsList] = useState([])
    const [expenseReceipt, setExpenseReceipt] = useState(undefined)
    const [numPages, setNumPages] = useState()
    const [pageNumber, setPageNumber] = useState(1)
    const [enable, setEnable] = useState(true)
    const token = localStorage.getItem("_crm__token")

    const compress = new Compress()

    const paidThroughList = ["Advance Tax", "Employee Advance", "Prepaid Expenses", "TCS Receivable", "TDS Receivable", "Petty Cash", "Undeposited Funds", "Furniture and Equipment", "Employee Reimbursements", "TCS Payable", "TDS Payable", "Construction Loans", "Mortgages", "Capital Stock", "Distributions", "Dividends Paid", "Drawings", "Investments", "Opening Balance Offset", "Owner's Equity"]

    const [receiptPreview, setReceiptPreview] = useState(null)

    const onDrop = (event) => {
        // Prevent the browser from opening the image
        event.preventDefault()
        event.stopPropagation()

        // Get the first file from the DataTransfer object
        let file = event.dataTransfer.files[0]

        // Save image data to state to be appended to form
        setExpenseReceipt(file)

        // Set image preview 
        const reader = new FileReader()
        reader.onload = (e) => {
            setReceiptPreview(e.target.result)
        }
        reader.readAsDataURL(file)
    }

    const onDragOver = (event) => event.preventDefault()

    const onFileChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            // Save image data to state to be appended to form
            setExpenseReceipt(event.target.files[0])

            // Set image preview 
            const reader = new FileReader()
            reader.onload = (e) => {
                setReceiptPreview(e.target.result)
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }

    const fetchExpenseAccountsList = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/expense-accounts`, { token })

        if (data.success) {
            setExpenseAccountsList(data.expenseAccounts)
        }
    }

    const fetchVendors = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-vendors`, { token })

        if (data.success) {
            setVendors(data.vendors)
        }
    }

    const fetchCustomers = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-customers`, { token })

        if (data.success) {
            setCustomers(data.customers)
        }
    }

    const handleCreateExpense = async () => {
        
        const formData = new FormData()

        formData.append('token', token)
        formData.append('expensedate', expenseDate)
        selectedExpenseAccount && formData.append('expenseaccount', selectedExpenseAccount._id)
        formData.append('amount', expenseAmount)
        formData.append('paidthrough', selectedPaidThrough)
        selectedVendor && formData.append('vendorhash', selectedVendor.hash)
        formData.append('invoice', invoice)
        selectedCustomer && formData.append('customerhash', selectedCustomer.hash)
        formData.append('note', notes)

        console.log({ expenseReceipt })

        if (expenseReceipt) {
            // PDFs
            if (expenseReceipt.type === "application/pdf") {
                formData.append('encodedreceipt', receiptPreview)
            }
            // Images
            else {
                const compressed = await compress.compress([expenseReceipt], {
                    size: 1,
                    quality: 0.65,
                    maxWidth: 1920,
                    maxHeight: 1920,
                    resize: true,
                    rotate: false,
                })

                const encodedimage = compressed[0].prefix + compressed[0].data

                formData.append('encodedreceipt', encodedimage)
            }
        }

        console.log("=> Create expense api called", formData)

        if (!expenseDate) {
            toast.error("Please select a date.", {
              autoClose: 3000,
            });
            return;
          }
        setEnable(false)
        const { data, status } = await axios.post(`${api}/Accounting/create-expense`, formData)
        console.log({ response: data })

        if (data.success) {
            setEnable(true)
            toast.success(data.message)
            setCreateExpense(false)
        } else {
            setEnable(true)
            toast.error(data.message)
        }
    }

    const onDocumentLoadSuccess = (numPages) => {
        setNumPages(numPages._pdfInfo.numPages)
    }

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
    }, [])

    useEffect(() => {
        fetchExpenseAccountsList()
    }, [expensesUpdatedRefresh])

    useEffect(() => {
        fetchVendors()
    }, [vendorsUpdatedRefresh])

    useEffect(() => {
        fetchCustomers()
    }, [customersUpdatedRefresh])

    return (
        <>
            {addNewVendorPopup ? <AddNewVendor setOpen={setAddNewVendorPopup} setVendorsUpdatedRefresh={setVendorsUpdatedRefresh} /> : undefined}
            {addNewCustomerPopup ? <AddNewCustomer setOpen={setAddNewCustomerPopup} setCustomersUpdatedRefresh={setCustomersUpdatedRefresh} /> : undefined}
            {addNewExpensePopup ? <AddNewExpense setOpen={setAddNewExpensePopup} setExpensesUpdatedRefresh={setExpensesUpdatedRefresh} /> : undefined}
            <div className="_9flg" onClick={() => {
                setExpenseAccountInputOpen(false)
                setPaidThroughInputOpen(false)
                setVendorInputOpen(false)
                setCustomerInputOpen(false)
            }}>
                <Container>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Date*
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="Expense Date"
                                            value={expenseDate}
                                            onChange={(value) => setExpenseDate(value)}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Expense Account*
                                </div>
                                <div>
                                    <div className="whingy-peep">
                                        <div className="poortith-loch">
                                            <div onClick={e => {
                                                e.stopPropagation()
                                                setExpenseAccountInputOpen(prev => !prev)
                                            }} className="salients-rap">
                                                {selectedExpenseAccount ? selectedExpenseAccount.title : "Select an account"}
                                            </div>
                                            <button onClick={e => {
                                                e.stopPropagation()
                                                setExpenseAccountInputOpen(prev => !prev)
                                            }}>
                                                <AiOutlineSearch />
                                            </button>
                                            {expenseAccountInputOpen ? <div onClick={e => e.stopPropagation()} className="cirrus-tee">
                                                <input
                                                    value={expenseAccountInput}
                                                    onChange={e => setExpenseAccountInput(e.target.value)}
                                                    placeholder="Search"
                                                />
                                                <div className="pullmans-tom">
                                                    {expenseAccountsList.filter(item => {
                                                        if (item.title.toLowerCase().includes(expenseAccountInput.toLowerCase())) {
                                                            return true
                                                        }
                                                        return false
                                                    }).map((expenseAccount, expenseAccountIndex) => {
                                                        return (
                                                            <div key={expenseAccountIndex} className="poetise-row" onClick={() => {
                                                                setSelectedExpenseAccount(expenseAccount)
                                                                setExpenseAccountInputOpen(false)
                                                            }}>
                                                                <div className="winked-flit">
                                                                    {expenseAccount.title}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="knife-labs" onClick={() => setAddNewExpensePopup(true)}>
                                                    <IoAddCircleSharp />
                                                    <span>New Account</span>
                                                </div>
                                            </div> : undefined}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Amount*
                                </div>
                                <div>
                                    <TextField
                                        value={expenseAmount}
                                        onChange={e => setExpenseAmount(e.target.value)}
                                        id="outlined-basic"
                                        label="Expense Amount"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Paid Through*
                                </div>
                                <div>
                                    <div className="whingy-peep">
                                        <div className="poortith-loch">
                                            <div onClick={e => {
                                                e.stopPropagation()
                                                setPaidThroughInputOpen(prev => !prev)
                                            }} className="salients-rap">
                                                {selectedPaidThrough ? selectedPaidThrough : "Select an account"}
                                            </div>
                                            <button onClick={e => {
                                                e.stopPropagation()
                                                setPaidThroughInputOpen(prev => !prev)
                                            }}>
                                                <AiOutlineSearch />
                                            </button>
                                            {paidThroughInputOpen ? <div onClick={e => e.stopPropagation()} className="cirrus-tee">
                                                <input
                                                    value={paidThroughInput}
                                                    onChange={e => setPaidThroughInput(e.target.value)}
                                                    placeholder="Search"
                                                />
                                                <div className="pullmans-tom">
                                                    {paidThroughList.filter(item => {
                                                        if (item.toLowerCase().includes(paidThroughInput.toLowerCase())) {
                                                            return true
                                                        }
                                                        return false
                                                    }).map((paidThrough, paidThroughIndex) => {
                                                        return (
                                                            <div key={paidThroughIndex} className="poetise-row" onClick={() => {
                                                                setSelectedPaidThrough(paidThrough)
                                                                setPaidThroughInputOpen(false)
                                                            }}>
                                                                <div className="winked-flit">
                                                                    {paidThrough}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div> : undefined}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Vendor
                                </div>
                                <div>
                                    <div className="whingy-peep">
                                        <div className="poortith-loch">
                                            <div onClick={e => {
                                                e.stopPropagation()
                                                setVendorInputOpen(prev => !prev)
                                            }} className="salients-rap">
                                                {selectedVendor ? (
                                                    selectedVendor.firstname + " " + selectedVendor.lastname
                                                ) : "Select vendor"}
                                            </div>
                                            <button onClick={e => {
                                                e.stopPropagation()
                                                setVendorInputOpen(prev => !prev)
                                            }}>
                                                <AiOutlineSearch />
                                            </button>
                                            {vendorInputOpen ? <div onClick={e => e.stopPropagation()} className="cirrus-tee">
                                                <input
                                                    value={vendorInput}
                                                    onChange={e => setVendorInput(e.target.value)}
                                                    placeholder="Search"
                                                />
                                                <div className="pullmans-tom">
                                                    {vendors.filter(item => {
                                                        const fullname = item.firstname + " " + item.lastname
                                                        const email = item.email

                                                        if (fullname.toLowerCase().includes(vendorInput.toLowerCase()) || email.toLowerCase().includes(vendorInput.toLowerCase())) {
                                                            return true
                                                        }
                                                        return false
                                                    }).map((vendor, vendorIndex) => {
                                                        return (
                                                            <div key={vendorIndex} className="poetise-row" onClick={() => {
                                                                setSelectedVendor(vendor)
                                                                setVendorInputOpen(false)
                                                            }}>
                                                                <div className="winked-flit">
                                                                    {vendor.firstname} {vendor.lastname}
                                                                </div>
                                                                <div className="wights-spar">
                                                                    {vendor.email}
                                                                </div>
                                                                <div className="grifting-dew">
                                                                    {vendor.currency.code}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="knife-labs" onClick={() => setAddNewVendorPopup(true)}>
                                                    <IoAddCircleSharp />
                                                    <span>New Vendor</span>
                                                </div>
                                            </div> : undefined}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Invoice
                                </div>
                                <div>
                                    <TextField
                                        value={invoice}
                                        onChange={e => setInvoice(e.target.value)}
                                        id="outlined-basic"
                                        label="Invoice Number"
                                        variant="outlined"
                                    />
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Notes
                                </div>
                                <div>
                                    <textarea
                                        className="cedes-sill"
                                        placeholder="Add notes"
                                        value={notes}
                                        onChange={e => setNotes(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="livider-vise">
                                <div className="bromisms-ars">
                                    Customer Name
                                </div>
                                <div>
                                    <div className="whingy-peep">
                                        <div className="poortith-loch">
                                            <div onClick={e => {
                                                e.stopPropagation()
                                                setCustomerInputOpen(prev => !prev)
                                            }} className="salients-rap">
                                                {selectedCustomer ? (
                                                    selectedCustomer.firstname + " " + selectedCustomer.lastname
                                                ) : "Select customer"}
                                            </div>
                                            <button onClick={e => {
                                                e.stopPropagation()
                                                setCustomerInputOpen(prev => !prev)
                                            }}>
                                                <AiOutlineSearch />
                                            </button>
                                            {customerInputOpen ? <div onClick={e => e.stopPropagation()} className="cirrus-tee">
                                                <input
                                                    value={customerInput}
                                                    onChange={e => setCustomerInput(e.target.value)}
                                                    placeholder="Search"
                                                />
                                                <div className="pullmans-tom">
                                                    {customers.filter(item => {
                                                        const fullname = item.firstname + " " + item.lastname
                                                        const email = item.email

                                                        if (fullname.toLowerCase().includes(vendorInput.toLowerCase()) || email.toLowerCase().includes(vendorInput.toLowerCase())) {
                                                            return true
                                                        }
                                                        return false
                                                    }).map((customer, customerIndex) => {
                                                        return (
                                                            <div key={customerIndex} className="poetise-row" onClick={() => {
                                                                setSelectedCustomer(customer)
                                                                setCustomerInputOpen(false)
                                                            }}>
                                                                <div className="winked-flit">
                                                                    {customer.firstname} {customer.lastname}
                                                                </div>
                                                                <div className="wights-spar">
                                                                    {customer.email}
                                                                </div>
                                                                <div className="grifting-dew">
                                                                    {customer.currency.code}
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="knife-labs" onClick={() => setAddNewCustomerPopup(true)}>
                                                    <IoAddCircleSharp />
                                                    <span>New Customer</span>
                                                </div>
                                            </div> : undefined}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wicks-nub">
                                <button onClick={() => handleCreateExpense()} disabled={!enable}>Save expense</button>
                                <button onClick={() => setCreateExpense(false)}>Cancel</button>
                            </div>
                        </div>
                        <div className="tacos-hire">
                            <div
                                className="image-upload"
                                onDrop={onDrop}
                                onDragOver={onDragOver}
                            >
                                <img src={GalleryIcon} alt="" />
                                <div>Drag or drop your receipts</div>
                                <div style={{ color: "grey", fontSize: "12px", marginTop: "10px" }}>or</div>
                                <input id="widows-plea" className="widows-plea" type="file" onChange={onFileChange} />
                                <label htmlFor="widows-plea">
                                    Upload your files
                                </label>
                            </div>
                            {receiptPreview && receiptPreview.includes("application/pdf") ? (
                                <div className="become-lek">
                                    <Document file={receiptPreview} onLoadSuccess={onDocumentLoadSuccess}>
                                        <Page width={240} pageNumber={pageNumber} />
                                    </Document>
                                    <p>
                                        Page {pageNumber} of {numPages}
                                    </p>
                                </div>
                            ) : (
                                <div className="filename-bubo">
                                    <img src={receiptPreview} alt="" />
                                </div>
                            )}
                        </div>
                    </div> 

                </Container>
            </div>
        </>
    )
}

export default CreateExpense

